module.exports = __webpack_public_path__ + "img/c1.bc96d35b.png";